import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import RawMaterialInventorySearch from "./raw-material-search";
import { POSRawMaterialModel } from "../../models/all-user/edit-user-model";
import RawMaterialInventoryDatatable from "./raw-material-datatable";
import posService from "../../services/pos/pos.service";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";

const RawmaterialInventoryMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [filteredRawMaterials, setfilteredRawMaterials] = useState<POSRawMaterialModel[]>([]);
  const [RawMaterialsList, setRawMaterialsList] = useState<POSRawMaterialModel[]>([]);
  const [loading, setLoading] = useState(false);

  const getAllProducts = (posId: number) => {
      RawMaterialService.GetposRawmaterials(posId).then((response) => {
      setRawMaterialsList(response);
      setfilteredRawMaterials(response);
      setLoading(false);
    });
  }
  
  function handleSearch(query: string): void {
    setLoading(true);
    if (RawMaterialsList && RawMaterialsList.length > 0) {
      const searchedProducts = RawMaterialsList.filter(
        (rawmaterial) =>
          rawmaterial.rawMaterialName &&
          typeof rawmaterial.rawMaterialName === "string" &&
          rawmaterial.rawMaterialName.toLowerCase().includes(query.toLowerCase())
      );
      setfilteredRawMaterials(searchedProducts);
    } else {
      setfilteredRawMaterials([]);
    }
    setTimeout(() => setLoading(false), 200);
  }


  const handlePOSChange = (posId: number) => {
  setLoading(true);
  getAllProducts(posId);
};

const handleAddSuccess = (posId: number) => {
    getAllProducts(posId); // refresh after adding
  };
  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <h5 className="ml-1 mb-0">{t("Raw Materials Inventory")}</h5>
          </div>
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <RawMaterialInventorySearch onSearch={handleSearch} setLoading={setLoading} onPOSChange={handlePOSChange} onAddSuccess={handleAddSuccess}/>
            </div>
          </div >
          <RawMaterialInventoryDatatable data={filteredRawMaterials}  onRefresh={handleAddSuccess} setLoading={setLoading} />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default RawmaterialInventoryMain;
